import * as ActionTypes from './actionTypes'

export const changeLang = lang => ({ type: ActionTypes.CHANGE_LAUGUAGE, lang })


// WEBPACK FOOTER //
// ./src/actions/languageAction.js